export default "__VITE_ASSET__CxMj7pSr__"